// src/components/Navbar.tsx
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Lock,
  LockOpen,
  Logout,
  Menu as MenuIcon,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../client/AuthProvider";
import { useEditMode } from "../context/EditModeContext";

export default function Navbar() {
  const { isEditMode, toggleEditMode } = useEditMode();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const { user, signOut } = useAuth();

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Timeline", path: "/timeline" },
    // { label: "Expertise", path: "/expertise" },
    { label: "Certifications", path: "/certifications" },
    { label: "Books", path: "/books" },
    { label: "Get in Touch", path: "/contact" },
  ];

  const handleDrawerToggle = () => setDrawerOpen(!drawerOpen);

  const drawer = (
    <Box sx={{ width: 250 }} role="presentation" onClick={handleDrawerToggle}>
      <List>
        {navItems.map((item) => (
          <ListItem
            component={Link}
            to={item.path}
            key={item.label}
          >
            {/* {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>} */}
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
        {user && (
          <ListItem onClick={toggleEditMode}>
            <ListItemIcon>
              {isEditMode ? <Lock /> : <LockOpen />}
            </ListItemIcon>
            <ListItemText primary={isEditMode ? "Exit Edit Mode" : "Enter Edit Mode"} />
          </ListItem>
        )}

        {user && (
          <ListItem onClick={signOut}>
            <ListItemIcon>
              <Logout sx={{ color: "error.main" }} />
            </ListItemIcon>
            <ListItemText primary="Logout" sx={{ color: "error.main" }} />
          </ListItem>
        )}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <Typography
            variant="h6"
            sx={{ flexGrow: 1, cursor: "pointer", textDecoration: "none", color: "inherit" }}
            component={Link}
            to="/"
          >
            Pramod Mahajan
          </Typography>

          {isMobile ? (
            <>
              <IconButton color="inherit" onClick={handleDrawerToggle}>
                <MenuIcon />
              </IconButton>
            </>
          ) : (
            <>
              {navItems.map((item) => (
                <Button
                  key={item.label}
                  color="inherit"
                  component={Link}
                  to={item.path}
                // startIcon={item.icon || undefined}
                >
                  {item.label}
                </Button>
              ))}

              {/* Only show edit mode toggle if user is logged in */}
              {user && (
                <Button
                  color={isEditMode ? "error" : "inherit"}
                  onClick={toggleEditMode}
                  startIcon={isEditMode ? <Lock /> : <LockOpen />}
                >
                  {isEditMode ? "Exit Edit Mode" : "Enter Edit Mode"}
                </Button>
              )}

              {/* Authentication */}
              {user && (
                <Button
                  color="error"
                  onClick={signOut}
                  startIcon={<Logout />}
                >
                  Logout
                </Button>
              )}
            </>
          )}

        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerToggle}>
        {drawer}
      </Drawer>
    </>
  );
}
